/** GxPickCard (screens §F6): one auto-picked story with its Project button; the projected one reads "On screen". */
import type { DebriefPickView } from "@bsim/contracts";
import { Icon } from "../theme/icons";
import { GxPill } from "../theme/GxPill";
import { PICK_LABELS } from "./RoomPreview";
import { pickHeadline, pickPrompt } from "../room/pickWords";

export function GxPickCard({ pick, onScreen, onProject }: { readonly pick: DebriefPickView; readonly onScreen: boolean; readonly onProject: () => void }) {
  return (
    <div className="gx-fac-pick" data-on-screen={onScreen} data-testid={`pick.${pick.pickId}`}>
      <div>
        <div className="gx-fac-pk">{PICK_LABELS[pick.kind]}</div>
        <div className="gx-fac-phl">{pickHeadline(pick)}</div>
        <div className="gx-fac-ppr">{pickPrompt(pick)}</div>
      </div>
      {onScreen
        ? <GxPill tone="gold">On screen</GxPill>
        : <button type="button" className="gx-btn gx-btn--secondary" onClick={onProject}><Icon name="room" size={14} />Project</button>}
    </div>
  );
}
